import { FormGroup, Label } from './styles/common';

// v2 of formInputs/FormInputTextarea — same prop contract, restyled via v2's
// shared FormGroup (its inputFieldStyles targets any .form-control child,
// textarea included).
export function FormInputTextarea({
  label, placeholder, rows, registration, error, valid, max, value, hint,
}) {
  return (
    <FormGroup>
      {label !== undefined
        && <Label>{label}</Label>}
      <textarea
        placeholder={placeholder}
        rows={rows}
        maxLength={max}
        value={value}
        className={`form-control ${valid ? 'is-valid' : ''} ${error ? 'is-invalid' : ''}`}
        {...registration}
      />
      <div className="invalid-feedback">
        {error}
      </div>
      {hint && <p className="form-input-hint">{hint}</p>}
    </FormGroup>
  );
}
